module.exports = __webpack_public_path__ + "img/1523202353.2a71cddc.jpg";